import { createTheme } from "@mui/material";
import { ThemeProvider } from "styled-components";
import { useState } from "react";
import ServiceTypeToggle from "../../components/shared/ServiceTypeToggle";
import SubscriptionDataTable from "../../components/ManageSubscription/SubscritionTable";
import OceanSubscriptionTable from "../../ocean/oceanComponent/OceanManageSubscription/OceanSubscriptionTable";
import "../../components/CommunicationTemplete/CommunicationTemplate.css";

const defaultTheme = createTheme();

const ManageSubscription = () => {
  const [activeTab, setActiveTab] = useState<"air" | "ocean">("air");

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1>Manage Communication</h1>
          <p>Configure who receives WhatsApp &amp; email milestone alerts for each shipment mode.</p>
        </div>
        <ServiceTypeToggle onTypeChange={setActiveTab} activeTab={activeTab} width="320px" />
      </div>

      {activeTab === "air" ? <SubscriptionDataTable /> : <OceanSubscriptionTable />}
    </ThemeProvider>
  );
};

export default ManageSubscription;